import { render, staticRenderFns } from "./brand-action.vue?vue&type=template&id=1eadcada&"
import script from "./brand-action.vue?vue&type=script&lang=js&"
export * from "./brand-action.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports